import { render, staticRenderFns } from "./CarrierDestinationPriceDeleteButton.vue?vue&type=template&id=6719b6c4&scoped=true&"
import script from "./CarrierDestinationPriceDeleteButton.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationPriceDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6719b6c4",
  null
  
)

export default component.exports